import { render, staticRenderFns } from "./LocationBasedBudget.vue?vue&type=template&id=4279ae49&scoped=true"
import script from "./LocationBasedBudget.vue?vue&type=script&lang=js"
export * from "./LocationBasedBudget.vue?vue&type=script&lang=js"
import style0 from "./LocationBasedBudget.vue?vue&type=style&index=0&id=4279ae49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279ae49",
  null
  
)

export default component.exports